import {localStorageSync} from 'ngrx-store-localstorage';
import * as fromRouter from '@ngrx/router-store';
import * as fromAuth from './auth.reducers';
import * as fromUser from './user.reducers';
import * as fromTenant from './tenant.reducers';
import * as fromCoupon from './coupon.reducers';
import * as fromProduct from './product.reducer';
import * as fromIngredient from './ingredient.reducer';
import * as fromTimeslots from './timeslots.reducer';
import * as fromClosures from './closures.reducers';
import * as fromRiders from './riders.reducer';
import * as fromCustomers from '../reducers/customers.reducers';
import * as fromZones from '../reducers/zones.reducer';
import * as fromStatistics from '../reducers/statistics.reducers'
import * as fromOrders from '../reducers/orders.reducers';
import * as fromPopups from '../reducers/popups.reducers';
import * as fromNotifications from '../reducers/notifications.reducers';

import { ActionReducer, ActionReducerMap, createFeatureSelector, MetaReducer } from '@ngrx/store';

export interface AppState {
  auth: fromAuth.AuthState;
  user: fromUser.UserState;
  router: fromRouter.RouterReducerState<any>;
  tenant: fromTenant.TenantState;
  coupon: fromCoupon.CouponState;
  product: fromProduct.ProductState;
  ingredient: fromIngredient.IngredientState,
  timeSlot: fromTimeslots.TimeSlotsState,
  zone: fromZones.ZonesState,
  closures: fromClosures.ClosureState,
  riders: fromRiders.RidersState,
  customers: fromCustomers.CustomersState,
  statistics: fromStatistics.StatisticsState,
  orders: fromOrders.OrderState,
  popups: fromPopups.PopupState,
  notifications: fromNotifications.NotificationState
}

export const reducers: ActionReducerMap<AppState> = {
  auth: fromAuth.reducer,
  user: fromUser.reducer,
  router: fromRouter.routerReducer,
  tenant: fromTenant.reducer,
  coupon: fromCoupon.reducer,
  product: fromProduct.reducer,
  ingredient: fromIngredient.reducer,
  timeSlot: fromTimeslots.reducer,
  closures: fromClosures.reducer,
  riders: fromRiders.reducer,
  customers: fromCustomers.reducer,
  zone: fromZones.reducer,
  statistics: fromStatistics.reducer,
  orders: fromOrders.reducer,
  popups: fromPopups.reducer,
  notifications: fromNotifications.reducer
};

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({
    keys: ['auth', { tenant: ['selectedStoreTenant'] }],
    rehydrate: true,
    storage: localStorage
  })(reducer);
}



export const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer, fromAuth.clearState];

export const selectAuthState = createFeatureSelector<fromAuth.AuthState>(
  "auth"
);
export const selectUserState = createFeatureSelector<fromUser.UserState>(
  "user"
);

export const selectCustomersState = createFeatureSelector<fromCustomers.CustomersState>(
  "customers"
);

export const selectCouponState = createFeatureSelector<fromCoupon.CouponState>(
  "coupon"
);

export const selectZonesState = createFeatureSelector<fromZones.ZonesState>(
  "zone"
)

export const selectRouter = createFeatureSelector<
  AppState,
  fromRouter.RouterReducerState<any>
>("router");

const {
  selectQueryParams,
  selectQueryParam,
  selectRouteParams,
  selectRouteParam,
  selectRouteData,
  selectUrl,
} = fromRouter.getRouterSelectors(selectRouter);

export const selectTenantState = createFeatureSelector<fromTenant.TenantState>(
  "tenant"
)

export const selectProductState = createFeatureSelector<fromProduct.ProductState>(
  "product"
)

export const selectIngredientState = createFeatureSelector<fromIngredient.IngredientState>(
  "ingredient"
)

export const selectTimeSlotsState = createFeatureSelector<fromTimeslots.TimeSlotsState>(
  "timeSlot"
)

export const selectClosuresState = createFeatureSelector<fromClosures.ClosureState>(
  "closures"
)

export const selectRidersState = createFeatureSelector<fromRiders.RidersState>(
  "riders"
)

export const selectStatisticsState = createFeatureSelector<fromStatistics.StatisticsState>(
  "statistics"
)

export const selectOrdersState = createFeatureSelector<fromOrders.OrderState>(
  "orders"
)

export const selectPopupsState = createFeatureSelector<fromPopups.PopupState>(
  "popups"
)

export const selectNotificationsState = createFeatureSelector<fromNotifications.NotificationState>(
  "notifications"
)

export const selectRouteId = selectRouteParam("id");
export const selectStatus = selectQueryParam("status");

